"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Highlights() {
  const {
    ref: headerRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const scrollerRef = useRef<HTMLDivElement | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const highlights = [{
    date: "14.03.2025",
    title: "REFORMA ART. 62",
    description: "Actualización inmediata de los criterios de riesgo conforme a las nuevas disposiciones de la UIF.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/reforma_art_62.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/reforma_art_62.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/reforma_art_62.png-wvc-sizes",
    alt: "Documento legal de reforma"
  }, {
    date: "27.02.2025",
    title: "SCREENING PEP",
    description: "Integración de listas PEP nacionales e internacionales para una debida diligencia robusta.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/screening_pep.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/screening_pep.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/screening_pep.png-wvc-sizes",
    alt: "Interfaz de screening"
  }, {
    date: "10.02.2025",
    title: "AVISOS UIF",
    description: "Automatización en la generación de avisos para sujetos obligados del Art. 17.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/avisos_uif.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/avisos_uif.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/avisos_uif.webp-wvc-sizes",
    alt: "Panel de control de avisos"
  }, {
    date: "22.01.2025",
    title: "EXPEDIENTES",
    description: "Gestión documental centralizada para auditorías impecables y trazabilidad total.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/expedientes_digitales.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/expedientes_digitales.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/expedientes_digitales.png-wvc-sizes",
    alt: "Gestión de archivos"
  }, {
    date: "08.01.2025",
    title: "KYC AUTOMATIZADO",
    description: "Validación de identidad en tiempo real para reducir riesgos operativos y legales.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/kyc_automation.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/kyc_automation.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/kyc_automation.png-wvc-sizes",
    alt: "Proceso de validación"
  }, {
    date: "18.12.2024",
    title: "LISTAS OFICIALES",
    description: "Monitoreo constante contra listas negras y bloqueadas para evitar sanciones.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/listas_oficiales.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/listas_oficiales.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687646/img/listas_oficiales.png-wvc-sizes",
    alt: "Monitoreo de listas"
  }];
  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const handleScroll = () => {
      const cards = scroller.querySelectorAll<HTMLElement>("[data-card]");
      if (!cards.length) return;
      const scrollerRect = scroller.getBoundingClientRect();
      let closestIndex = 0;
      let closestDistance = Infinity;
      cards.forEach((card, i) => {
        const rect = card.getBoundingClientRect();
        const distance = Math.abs(rect.left - scrollerRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });
      setActiveIndex(closestIndex);
    };
    scroller.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => scroller.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToCard = (direction: "prev" | "next") => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const cards = scroller.querySelectorAll<HTMLElement>("[data-card]");
    if (!cards.length) return;
    const targetIndex = direction === "next" ? Math.min(activeIndex + 1, cards.length - 1) : Math.max(activeIndex - 1, 0);
    const target = cards[targetIndex];
    if (target) {
      scroller.scrollTo({
        left: target.offsetLeft,
        behavior: "smooth"
      });
    }
  };
  const totalCards = highlights.length;
  const counterCurrent = String(activeIndex + 1).padStart(2, "0");
  const counterTotal = String(totalCards).padStart(2, "0");
  const progressPercent = (activeIndex + 1) / totalCards * 100;
  return;
}